<app-material>
    <ng-container header>
        <div class="header">
            <div class="top-buttons">
                <h2>{{ 'admin.partNumbers.table.title' | translate }}</h2>
                <div class="mutators">
                    <app-button [class.disabled]="isSyncInProgress()"
                                (clicked)="openPartNumberModal()"
                                *ngIf="shouldRenderModifiers()">
                        {{ 'admin.partNumbers.buttons.addPartNumbers' | translate }}
                    </app-button>

                    <app-button style="float: right"
                                [class.disabled]="isSyncInProgress()|| this.isDownloadInProgress"
                                (clicked)="onDownloadPartNumReport()">
                        {{ 'reportDownloadForm.downloadButton' | translate }}
                    </app-button>
                </div>
            </div>
            <div *ngIf="shouldRenderModifiers()" class="bottom-buttons">
                <div class="sync-buttons">
                    <app-button *ngIf="isSyncInProgress()"
                                (clicked)="getSyncStatus()">
                        <i class="fa fa-refresh"></i>
                    </app-button>
                    <app-button *ngIf="!isSyncInProgress()"
                                [class.disabled]="this.isDownloadInProgress"
                                style="float: right"
                                (clicked)="openSyncModal()">
                        {{ 'admin.partNumbers.buttons.sync' | translate }}
                    </app-button>
                    <span>
                        {{ 'admin.partNumbers.table.sync.status.label' | translate }}
                        : {{ 'admin.partNumbers.table.sync.status.' + syncStatus?.status | translate }}
                    </span>
                    <span *ngIf="syncStatus?.endTime">
                        {{ 'admin.partNumbers.table.sync.lastSynced' | translate }}: {{ syncStatus?.endTime }}
                    </span>
                </div>
                <app-alert [class.hidden]="!(isSyncInProgress())"
                           type="info"
                           message="{{'admin.partNumbers.table.sync.warning' | translate}}">
                </app-alert>
            </div>
        </div>
    </ng-container>
    <ng-container body>
        <app-partnumber-table [partNumbers]="partNumbers"
                              [tableConfig]="tableConfig"
                              [statusFilters]="filterStatusList"
                              [readOnly]="hasPermission()"
                              [isLoading]="isLoadingPartNumbers"
                              [hasTitle]="false"
                              [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                              (sortChange)="onSortChange($event)"
                              (filterChange)="onFilter($event)"
                              (rowClick)="onTableRowClick($event)"
                              (duplicateRow)="onDuplicateRow($event)"
                              (pageChange)="onPageChange($event)">
        </app-partnumber-table>
    </ng-container>
</app-material>
<app-partnumber-modal
    [isReadOnly]="!shouldRenderModifiers()"
    [isLoading]="isLoadingModal"
    (onCreate)="createPartNumber($event)"
    (onUpdate)="updatePartNumber($event)"
    (onDelete)="deletePartNumber($event)">
</app-partnumber-modal>
<app-confirmation-modal #syncModal
                        title="{{'admin.partNumbers.table.sync.modal.title' | translate }}"
                        question="{{'admin.partNumbers.table.sync.modal.message' | translate}}"
                        [showConfirmButton]="true"
                        [isConfirmationInProgress]="isLoadingSyncStatus"
                        (confirmEvent)="onSyncPartNumbers()"
                        [confirmOnlyMode]="true">
</app-confirmation-modal>
